import { Typography, TypographyProps } from '@ocx/ui';

import { OfferCardVariant } from '../offer-card.types';

export type OfferCardTitleProps = {
  children: React.ReactNode;
  variant: OfferCardVariant;
  textAlign?: TypographyProps['textAlign'];
  'data-testid'?: string;
};

export const OfferTitle = ({ children, variant, textAlign, 'data-testid': dataTestId }: OfferCardTitleProps) => {
  return (
    <Typography
      variant={variant !== 'carousel' ? 'subtitle1' : 'subtitle2'}
      textAlign={textAlign}
      data-testid={dataTestId}>
      {children}
    </Typography>
  );
};
